import { Image } from '@chakra-ui/react'
import { useColorMode } from '@components/ui/color-mode'
import ArgosLogo from '@assets/argos_logo.png'
import ArgosWhiteLogo from '@assets/argos_white_logo.png'

interface Props {
  width?: string | number;
}

const Logo = ({ width = 150 }:Props) => {
  const { colorMode } = useColorMode();
  
  return (
    <Image src={colorMode === "light" ? ArgosLogo : ArgosWhiteLogo} alt="logo" width={width} />
  );
};

export default Logo;
